import { IOption, LocaleKeyEnum } from 'types';

import deLocale from 'dayjs/locale/de';
import deCHLocale from 'dayjs/locale/de-ch';
import enGBLocale from 'dayjs/locale/en-gb';
import itLocale from 'dayjs/locale/it';
import itCHLocale from 'dayjs/locale/it-ch';
import frLocale from 'dayjs/locale/fr';
import plLocale from 'dayjs/locale/pl';
import csLocale  from 'dayjs/locale/cs';

export const languages: IOption<LocaleKeyEnum>[] = [
  { label: 'language.german', value: 'de-DE' as LocaleKeyEnum },
  { label: 'language.english', value: 'en-US' as LocaleKeyEnum },
  { label: 'language.italian', value: 'it-IT' as LocaleKeyEnum },
  { label: 'language.french', value: 'fr-FR' as LocaleKeyEnum },
  { label: 'language.polish', value: 'pl-PL' as LocaleKeyEnum },
  { label: 'language.czech', value: 'cs-CZ' as LocaleKeyEnum },
];

export const storeLanguageToLocale = {
  de: 'de-DE' as LocaleKeyEnum,
  en: 'en-US' as LocaleKeyEnum,
  it: 'it-IT' as LocaleKeyEnum,
  fr: 'fr-FR' as LocaleKeyEnum,
  pl: 'pl-PL' as LocaleKeyEnum,
  cs: 'cs-CZ' as LocaleKeyEnum,
};

export const localeToStoreLanguage = {
  ['de-DE' as LocaleKeyEnum]: 'de',
  ['en-US' as LocaleKeyEnum]: 'en',
  ['it-IT' as LocaleKeyEnum]: 'it',
  ['fr-FR' as LocaleKeyEnum]: 'fr',
  ['pl-PL' as LocaleKeyEnum]: 'pl',
  ['cs-CZ' as LocaleKeyEnum]: 'cs',
}

export const localeToDayjsLocale = {
  ['de-DE' as LocaleKeyEnum]: deLocale,
  ['de-CH' as LocaleKeyEnum]: deCHLocale,
  ['en-US' as LocaleKeyEnum]: enGBLocale,
  ['it-IT' as LocaleKeyEnum]: itLocale,
  ['ch-IT' as LocaleKeyEnum]: itCHLocale,
  ['fr-FR' as LocaleKeyEnum]: frLocale,
  ['pl-PL' as LocaleKeyEnum]: plLocale,
  ['cs-CZ' as LocaleKeyEnum]: csLocale,
}
